import React, { useState } from "react";

// Collapsible Section Component
const CollapsibleSection = ({ title, content, expanded }) => {
    const [isExpanded, setIsExpanded] = useState(expanded);

    const toggleSection = () => {
        setIsExpanded((prev) => !prev);
    };

    return (
        <div style={{ marginBottom: "1rem" }}>
            <h2
                style={{
                    fontSize: '16px',
                    fontWeight: "600",
                    padding: "1rem",
                    margin: 0,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    cursor: "pointer",
                    background: "linear-gradient(90deg, #771615 0%, #FF9800 100%)",
                    color: "white",
                }}
                onClick={toggleSection}
            >
                {title}
                <span style={{ fontSize: "1.2rem" }}>{isExpanded ? "▲" : "▼"}</span>
            </h2>
            {isExpanded && (
                <div
                    style={{
                        padding: "1rem",
                        transition: "max-height 0.3s ease-in-out",
                        background: "linear-gradient(to top, #fff 0%, rgba(255, 152, 0, 0.5) 100%)",
                    }}
                    dangerouslySetInnerHTML={{ __html: content }}
                ></div>
            )}
        </div>
    );
};

export default CollapsibleSection;